import type { AnyRouter } from '@tanstack/react-router';
import { capture } from '@tupai/analytics/client';

/** The API-sent path when this build has a route for it; otherwise null. */
export function resolveNotificationLink(
  router: AnyRouter,
  link: string | null | undefined
): string | null {
  if (!link) return null;
  // App paths only: never a full or protocol-relative URL.
  if (link.startsWith('/') && !link.startsWith('//')) {
    const { pathname } = new URL(link, window.location.origin);
    const [, params, found] = router.getMatchedRoutes(pathname);
    // A fuzzy match puts the unmatched remainder in `**`; that path would 404.
    if (found && !params['**']) return link;
  }
  capture('notification_link_unmatched', { link });
  return null;
}
